import { createAsyncThunk } from '@reduxjs/toolkit';
import { createEmployee, getEmployee, getEmployees, getTentativeEmployees, updateEmployee, uploadEmployeeNotice, uploadEmployeePhoto } from '../api/employeesApi';
import { showAlert } from '../slices/alertsSlice';
import { setCurrentEmployee, setEmployeesList, setTentativeEmployee } from '../slices/employeesSlice';
import { handleError } from '../slices/errorsSlice';
import { startLoading, endLoading } from '../slices/loadingSlice';

export const getEmployeesList = createAsyncThunk('employees/getEmployeesList', ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getEmployees(token, query)
    .then(response => response.status === 200 ? response.json() : Promise.reject(response))
    .then(data => dispatch(setEmployeesList({ employees: data.employees })))
    .catch(err => dispatch(handleError(err)))
    .finally(() => dispatch(endLoading()));
});

export const getCurrentEmployee = createAsyncThunk('employees/getCurrentEmployee', ({ id }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getEmployee(token, id)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setCurrentEmployee({ employee: data.employee })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const createNewEmployee = createAsyncThunk('employees/createNewEmployee', ({ employee, callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  createEmployee(token, employee)
  .then(response => response.status === 201 ? response.json() : Promise.reject(response))
  .then(data => callback(data.employee))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const updateCurrentEmployee = createAsyncThunk('employees/updateCurrentEmployee', ({ id, employee }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  updateEmployee(token, id, employee)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setCurrentEmployee({ employee: data.employee })))
  .then(() => dispatch(showAlert({ message: 'Empleado actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const uploadCurrentEmployeePhoto = createAsyncThunk('employees/uploadCurrentEmployeePhoto', ({ id, photo }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  uploadEmployeePhoto(token, id, photo)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => setTimeout(() => dispatch(setCurrentEmployee({ employee: data.employee })), 1000))
  .then(() => dispatch(showAlert({ message: 'Empleado actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const uploadCurrentEmployeeNotice = createAsyncThunk('employees/uploadCurrentEmployeeNotice', ({ id, notice }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  uploadEmployeeNotice(token, id, notice)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setCurrentEmployee({ employee: data.employee })))
  .then(() => dispatch(showAlert({ message: 'Empleado actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const findTentativeEmployee = createAsyncThunk('employees/findTentativeEmployee', ({ identityNumber }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getTentativeEmployees(token, identityNumber)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => data.data)
  .then(employees => employees?.length > 0 ? dispatch(setTentativeEmployee({ employee: employees[0] })) : null)
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});
